import { CustomPreloader } from '@components'

import './suspenseFallback.scss'

const SuspenseFallback = () => (
  <div className='suspense-fallback-wrapper'>
    <CustomPreloader />
  </div>
)

export default SuspenseFallback
